// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__yYSO_","select":"styles_select__3uFK5"};